import React from "react";
import { Header } from "@/components/Header";

const PrivacyPage = () => (
  <div className="min-h-screen bg-white">
    <Header />
    <div className="container mx-auto px-6 py-12 max-w-4xl">
      <h1 className="text-3xl font-bold text-gray-900 mb-8">Privacy Policy</h1>
      <div className="prose prose-gray max-w-none">
        <p className="text-gray-600 mb-6">Last updated: January 2026</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">1. Information We Collect</h2>
        <p className="text-gray-600 mb-4">We collect information you provide during registration, applications, and platform usage including: name, email, company details, and professional background.</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">2. How We Use Your Information</h2>
        <ul className="list-disc pl-6 text-gray-600 mb-4">
          <li>Process applications and program enrollment</li>
          <li>Facilitate connections between founders and investors</li>
          <li>Send program updates and communications</li>
          <li>Improve our services and platform</li>
        </ul>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">3. Data Protection</h2>
        <p className="text-gray-600 mb-4">We implement industry-standard security measures to protect your data. Contact details shared through our platform are protected and only revealed with mutual consent.</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">4. Investor-Founder Privacy</h2>
        <p className="text-gray-600 mb-4">Personal contact information (email, phone) of investors and founders is not publicly displayed. All communication is facilitated through the SKI AXIS platform to protect privacy.</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">5. Cookies</h2>
        <p className="text-gray-600 mb-4">We use essential cookies for authentication and platform functionality. No third-party tracking cookies are used.</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">6. Your Rights</h2>
        <p className="text-gray-600 mb-4">You may request access to, correction of, or deletion of your personal data by contacting us.</p>
        
        <h2 className="text-xl font-semibold mt-8 mb-4">7. Contact</h2>
        <p className="text-gray-600 mb-4">For privacy inquiries: neha.dewan@skiasia.org</p>
        
        <div className="mt-12 p-6 bg-gray-50 rounded-lg">
          <p className="text-sm text-gray-500"><strong>Data Controller:</strong><br />SKI Asia Pacific FZCO<br />Dubai Silicon Oasis, UAE<br />Phone: +971 52 965 0406</p>
        </div>
      </div>
    </div>
  </div>
);

export default PrivacyPage;
